// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.custom-extension-modal_modal-content_PD3ub {
    max-width: 550px;
    margin-top: 50px;
}

.custom-extension-modal_body_SyyBd {
    background: var(--ui-white);
    padding: 1.5rem 2.25rem;
}

.custom-extension-modal_body_SyyBd p,
.custom-extension-modal_unsandboxed-container_qNk5Y,
.custom-extension-modal_url-input_jC64Z,
.custom-extension-modal_text-code-input_bToYJ {
    margin: 1rem 0;
    display: block;
}

.custom-extension-modal_type-selector-container_UB6rD {
    display: flex;
    justify-content: space-around;
}

.custom-extension-modal_type-selector-button_m1AOu {
    width: 100%;
    cursor: pointer;
    border-bottom: 0.25rem solid var(--ui-tertiary);
    margin: 0 1rem;
    padding: 0.5rem 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.custom-extension-modal_type-selector-button_m1AOu[data-active="true"] {
    border-color: var(--looks-secondary);
}

.custom-extension-modal_type-selector-button_m1AOu:active {
    border-color: var(--looks-transparent);
}

.custom-extension-modal_url-input_jC64Z,
.custom-extension-modal_text-code-input_bToYJ {
    width: 100%;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 0.25rem;
    padding: 0.5rem;
    font-size: inherit;
}

.custom-extension-modal_url-input_jC64Z {
    height: 3rem;
}

.custom-extension-modal_text-code-input_bToYJ {
    min-height: 3rem;
    height: 8rem;
    min-width: 100%;
    max-width: 100%;
    font-family: monospace;
}

.custom-extension-modal_unsandboxed-container_qNk5Y {
    display: flex;
    align-items: center;
}

.custom-extension-modal_unsandboxed-checkbox_QHsd1 {
    margin-right: 0.5rem;
}

.custom-extension-modal_trusted-extension_yDWPb,
.custom-extension-modal_unsandboxed-warning_Crwc3 {
    padding: 0.5rem;
    border-radius: 0.25rem;
}

.custom-extension-modal_trusted-extension_yDWPb {
    background-color: rgba(94, 255, 94, 0.25);
    border: 1px solid green;
}

.custom-extension-modal_unsandboxed-warning_Crwc3 {
    background-color: rgba(255, 81, 81, 0.25);
    border: 1px solid red;
}

.custom-extension-modal_unsandboxed-warning_Crwc3 > *:not(:last-child) {
    display: block;
    margin-bottom: 4px;
}

.custom-extension-modal_button-row_CTGAf {
    display: flex;
    justify-content: flex-end;
}

.custom-extension-modal_load-button_Ywkh3 {
    font: inherit;
    color: inherit;
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    border: 1px solid var(--ui-black-transparent);
    font-weight: 600;
    font-size: 0.85rem;
    color: white;
    background: var(--looks-secondary);
}

.custom-extension-modal_load-button_Ywkh3:disabled {
    opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-custom-extension-modal/custom-extension-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;;;;IAII,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,+CAA+C;IAC/C,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;IAEI,WAAW;IACX,6CAA6C;IAC7C,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,yCAAyC;IACzC,uBAAuB;AAC3B;;AAEA;IACI,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,sBAAsB;IACtB,6CAA6C;IAC7C,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,YAAY;AAChB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n    max-width: 550px;\n    margin-top: 50px;\n}\n\n.body {\n    background: var(--ui-white);\n    padding: 1.5rem 2.25rem;\n}\n\n.body p,\n.unsandboxed-container,\n.url-input,\n.text-code-input {\n    margin: 1rem 0;\n    display: block;\n}\n\n.type-selector-container {\n    display: flex;\n    justify-content: space-around;\n}\n\n.type-selector-button {\n    width: 100%;\n    cursor: pointer;\n    border-bottom: 0.25rem solid var(--ui-tertiary);\n    margin: 0 1rem;\n    padding: 0.5rem 0;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.type-selector-button[data-active=\"true\"] {\n    border-color: var(--looks-secondary);\n}\n\n.type-selector-button:active {\n    border-color: var(--looks-transparent);\n}\n\n.url-input,\n.text-code-input {\n    width: 100%;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 0.25rem;\n    padding: 0.5rem;\n    font-size: inherit;\n}\n\n.url-input {\n    height: 3rem;\n}\n\n.text-code-input {\n    min-height: 3rem;\n    height: 8rem;\n    min-width: 100%;\n    max-width: 100%;\n    font-family: monospace;\n}\n\n.unsandboxed-container {\n    display: flex;\n    align-items: center;\n}\n\n.unsandboxed-checkbox {\n    margin-right: 0.5rem;\n}\n\n.trusted-extension,\n.unsandboxed-warning {\n    padding: 0.5rem;\n    border-radius: 0.25rem;\n}\n\n.trusted-extension {\n    background-color: rgba(94, 255, 94, 0.25);\n    border: 1px solid green;\n}\n\n.unsandboxed-warning {\n    background-color: rgba(255, 81, 81, 0.25);\n    border: 1px solid red;\n}\n\n.unsandboxed-warning > *:not(:last-child) {\n    display: block;\n    margin-bottom: 4px;\n}\n\n.button-row {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.load-button {\n    font: inherit;\n    color: inherit;\n    padding: 0.75rem 1rem;\n    border-radius: 0.25rem;\n    border: 1px solid var(--ui-black-transparent);\n    font-weight: 600;\n    font-size: 0.85rem;\n    color: white;\n    background: var(--looks-secondary);\n}\n\n.load-button:disabled {\n    opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `custom-extension-modal_modal-content_PD3ub`;
export { _1 as "modal-content" };
export var modalContent = `custom-extension-modal_modal-content_PD3ub`;
export var body = `custom-extension-modal_body_SyyBd`;
var _2 = `custom-extension-modal_unsandboxed-container_qNk5Y`;
export { _2 as "unsandboxed-container" };
export var unsandboxedContainer = `custom-extension-modal_unsandboxed-container_qNk5Y`;
var _3 = `custom-extension-modal_url-input_jC64Z`;
export { _3 as "url-input" };
export var urlInput = `custom-extension-modal_url-input_jC64Z`;
var _4 = `custom-extension-modal_text-code-input_bToYJ`;
export { _4 as "text-code-input" };
export var textCodeInput = `custom-extension-modal_text-code-input_bToYJ`;
var _5 = `custom-extension-modal_type-selector-container_UB6rD`;
export { _5 as "type-selector-container" };
export var typeSelectorContainer = `custom-extension-modal_type-selector-container_UB6rD`;
var _6 = `custom-extension-modal_type-selector-button_m1AOu`;
export { _6 as "type-selector-button" };
export var typeSelectorButton = `custom-extension-modal_type-selector-button_m1AOu`;
var _7 = `custom-extension-modal_unsandboxed-checkbox_QHsd1`;
export { _7 as "unsandboxed-checkbox" };
export var unsandboxedCheckbox = `custom-extension-modal_unsandboxed-checkbox_QHsd1`;
var _8 = `custom-extension-modal_trusted-extension_yDWPb`;
export { _8 as "trusted-extension" };
export var trustedExtension = `custom-extension-modal_trusted-extension_yDWPb`;
var _9 = `custom-extension-modal_unsandboxed-warning_Crwc3`;
export { _9 as "unsandboxed-warning" };
export var unsandboxedWarning = `custom-extension-modal_unsandboxed-warning_Crwc3`;
var _a = `custom-extension-modal_button-row_CTGAf`;
export { _a as "button-row" };
export var buttonRow = `custom-extension-modal_button-row_CTGAf`;
var _b = `custom-extension-modal_load-button_Ywkh3`;
export { _b as "load-button" };
export var loadButton = `custom-extension-modal_load-button_Ywkh3`;
export default ___CSS_LOADER_EXPORT___;
